import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import CommissionsPermissionsContext from '../contexts/CommissionsPermissionsContext.jsx';
import RepDisplayName from './RepDisplayName.jsx';

function RepSelector({ ignoreReps = ['SPLIT COMMISSIONS'], onChange, selectedRep }) {
  const { commissionsPermissions } = React.useContext(CommissionsPermissionsContext);

  const filteredCommissionsPermissions = React.useMemo(() => {
    return commissionsPermissions.filter((item) => !ignoreReps.includes(item.rep));
  }, [commissionsPermissions, ignoreReps]);

  const handleSelectedRep = React.useCallback(
    (e) => {
      const newValue = e.target.value;
      if (onChange) {
        onChange(newValue);
      }
    },
    [onChange]
  );

  return (
    <FormControl>
      <InputLabel id="rep-label-id">Rep</InputLabel>
      <Select
        label="Rep"
        labelId="rep-label-id"
        size="small"
        value={selectedRep}
        onChange={handleSelectedRep}
        sx={{ height: '3.125rem', mx: 0, padding: '0.625rem', minWidth: '5.25rem' }}
        data-cy="rep-select"
      >
        {filteredCommissionsPermissions.map((permission, idx) => (
          <MenuItem key={`${permission.rep}`} value={permission.rep} data-cy={`rep-select-${idx}`}>
            <RepDisplayName rep={permission.rep} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

RepSelector.propTypes = {
  ignoreReps: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  selectedRep: PropTypes.string,
};

export default React.memo(RepSelector);
